export type {
  MapFilters,
  MultipleValueFilterOption,
  SingleValueFilterOption,
} from "@repo/shared-types";

import {
  MapFilter,
  MapFilterBase,
  MapFilterParameterName,
  MultipleValueFilter,
  NestedMultipleValueFilter,
  SingleValueFilter,
} from "@repo/shared-types";

export function isSingleOption(
  value: MapFilter
): value is SingleValueFilter<MapFilterParameterName, MapFilterBase> {
  return value.type === "single";
}

export function isFlatMultipleOptions(
  value: MapFilter
): value is MultipleValueFilter<MapFilterParameterName, MapFilterBase> {
  return (
    value.type === "multiple" &&
    value.values.every(i => typeof i.value === "string")
  );
}

export function isNestedMultipleOptions(
  value: MapFilter
): value is NestedMultipleValueFilter<MapFilterParameterName, MapFilterBase> {
  return (
    value.type === "multiple" && value.values.every(i => Array.isArray(i.value))
  );
}
